import List from "./List";
import Create from "./Create";
import Show from "./Show";
import Edit from "./Edit";

export const UserList = List;
export const UserCreate = Create;
export const UserShow = Show;
export const UserEdit = Edit;
